// components/common/Card.jsx
import React from 'react';

const Card = ({ children, className = '', ...props }) => {
  return (
    <div 
      className={`bg-white rounded-2xl shadow-lg p-6  ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};

export default Card;